import { WebStorageStateStore } from 'oidc-client';
const browserUrl = window.location;
const baseUrl = browserUrl.protocol + '//' + browserUrl.host;

export const IDENTITY_CONFIG = {
	authority: process.env.REACT_APP_IDENTITY_AUTHORITY,
	// client_id: 'localhost',
	client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID, // production
	automaticSilentRenew: true,
	...(browserUrl.pathname !== '/register/start' && {redirect_uri: `${baseUrl}/auth/callback`}),
	...(browserUrl.pathname === '/register/start' && {redirect_uri: `${baseUrl}/register/callback`}),
	response_type: 'code',
	scope: 'openid profile email skopei_api offline_access',
	// scope: 'openid profile email skopei_api',
	post_logout_redirect_uri: `${baseUrl}/auth/login`,
	silent_redirect_uri: `${baseUrl}/auth/silent`,
	// revokeAccessTokenOnSignout: true
	userStore: new WebStorageStateStore({ store: window.localStorage }),
	filterProtocolClaims: true,
	loadUserInfo: true,
	monitorSession: false,
	// ...(browserUrl.pathname === '/password/reset' && {
	//   metadata: {
	//     authorization_endpoint: 'https://skopei-services-identity-develop.azurewebsites.net/connect/updatepassword',
	//   }})
};
